module.exports = __webpack_public_path__ + "img/lupa_vazia_1.540a9d85.svg";